// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"ca928530","875":"ca928530"}[chunkId] + ".chunk.css";
};